"use strict";

exports.__esModule = true;
exports.DashboardListScreen = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Core = require("../../Core");
var _Auth = require("../../Auth");
var _App = require("../../App");
var _DashboardCollection = require("../DashboardCollection");
var _API = require("../../API");
var _DashboardListAccoridanView = require("../DashboardList/DashboardListAccoridanView");
var _System = require("../../../System");
var _Theme = require("../../Theme");
var _DashboardTagContext = require("../DashboardTagContext");
var _AiCreateButton = require("../../AI/Authoring/AiCreateButton");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var DashboardListContainer = _styledComponents["default"].div.withConfig({
  displayName: "DashboardListScreen__DashboardListContainer",
  componentId: "sc-1uex3uk-0"
})(["display:flex;flex:1;overflow-y:auto;flex-direction:column;justify-content:stretch;height:calc(100vh - (", " + ", "));"], (0, _Theme.val)("NavbarHeight"), (0, _Theme.val)("ToolbarHeight"));

/**
 * Screen which shows a list of dashboards for the plant.
 */
var DashboardListScreen = exports.DashboardListScreen = (0, _Core.withTranslator)(function (props) {
  var translate = props.translator.translate;
  var _useState = (0, _react.useState)(""),
    searchTerm = _useState[0],
    setSearchTerm = _useState[1];
  var dashboardCollection = _react["default"].useContext(_DashboardCollection.DashboardCollectionContext);
  var handleSearchChange = function handleSearchChange(searchTerm) {
    setSearchTerm(searchTerm);
  };
  return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
    title: translate("DashboardListScreen.title", "Dashboards"),
    "data-testid": "DashboardListScreen"
  }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
    title: translate("DashboardListScreen.navbar.title", "Dashboards")
  }), /*#__PURE__*/_react["default"].createElement(_Core.Toolbar, null, /*#__PURE__*/_react["default"].createElement(_Core.SearchInput, {
    value: searchTerm,
    onChange: handleSearchChange
  }), /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: "CREATE_DASHBOARDS"
  }, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
    style: {
      marginLeft: "auto"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
    icon: _icons.IconNames.ADD,
    to: (0, _System.getScreenURL)("CreateDashboard"),
    intent: _core.Intent.PRIMARY
  }, translate("DashboardListScreen.createDashboardButton.text", "Create Dashboard"))), /*#__PURE__*/_react["default"].createElement(_AiCreateButton.AiCreateButton, {
    kind: "dashboard",
    style: {
      marginLeft: 6
    }
  }))), /*#__PURE__*/_react["default"].createElement(DashboardListContainer, null, /*#__PURE__*/_react["default"].createElement(_API.CollectionSearcher, {
    collection: dashboardCollection,
    term: searchTerm
  }, function (_ref) {
    var data = _ref.data,
      error = _ref.error;
    if (error) {
      return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
        error: error
      });
    }
    if (!data) {
      return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
    }
    return /*#__PURE__*/_react["default"].createElement(_DashboardTagContext.DashboardTagContext.Consumer, null, function (tagContext) {
      if (tagContext && tagContext.loading) {
        return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
      }
      var dashboardTags = tagContext ? tagContext.data : [];
      return /*#__PURE__*/_react["default"].createElement(_DashboardListAccoridanView.DashboardListAccoridanView, {
        items: data,
        tags: dashboardTags
      });
    });
  })));
});